import { mount } from 'svelte'

import createEduMedicalStudentStores from '../stores/createEduMedicalStudentStores'

import DecorativeDonut from '../../components/projects/facts-and-figures/composite/DecorativeDonut.svelte'
import GenericDonut from '../../components/projects/facts-and-figures/highcharts/GenericDonut.svelte'
import LabelValueParagraph from '../../components/projects/facts-and-figures/core/visual/LabelValueParagraph.svelte'
import SoloBarChart from '../../components/projects/facts-and-figures/composite/SoloBarChart.svelte'
import StandardDonut from '../../components/projects/facts-and-figures/composite/StandardDonut.svelte'
import Ghost from '../../components/lib/Ghost.svelte'

/**
 * Fetch data for Edu MedicalStudent; mount components with data stores
 */
export default function () {
  const [
    data, // the main store; will hold ALL data fetched
    loading, // will be true until the data fetching is done, can be used in components for loading state
    error, // if the fetches went completely sideways, this will be truthy, and can be used in components
    
    edumedDerived,
    genderDerived,
    gpaDerived,
    mcatDerived,
    meandebtloadDerived,
    stepmeanscoresDerived,
    tuitionDerived,
    uscanadascoresDerived
  ] = createEduMedicalStudentStores()
  
  // @TODO sandbox page (if anyone ever needs one)

  if(document.getElementById('totalDoc')) {
    mount(DecorativeDonut, {
      target: document.getElementById('totalDoc'),
      props: {
        store: edumedDerived,
        // max: Object.values(doctorOFMedicineStudentsData)[0] /* do we need DecorativeDonut here?  */
      }
    })
  }

  if(document.getElementById('gpa')) {
    mount(StandardDonut, {
      target: document.getElementById('gpa'),
      props: {
        store: gpaDerived,
        max: '4',
        isDecimal: true,
      }
    })
  }

  if(document.getElementById('mcat')) {
    mount(StandardDonut, {
      target: document.getElementById('mcat'),
      props: {
        store: mcatDerived,
        max: '528',
        label: 'MCAT Median',
      }
    })
  }

  if(document.getElementById('mean-debt-load')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('mean-debt-load'),
      props: {
        prefix: '$',
        store: meandebtloadDerived,
        animateNumbers: true,
      }
    })
  }

  if(document.getElementById('step-mean-scores')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('step-mean-scores'),
      props: {
        store: stepmeanscoresDerived,
        suffix: '/100%'
      }
    })
  }

  if(document.getElementById('tuition-in-and-out')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('tuition-in-and-out'),
      props: {
        store: tuitionDerived,
        prefix: '$',
        animateNumbers: true,
      }
    })
  }

  if(document.getElementById('us-canada-scores')) {
    mount(LabelValueParagraph, {
      target: document.getElementById('us-canada-scores'),
      props: {
        store: uscanadascoresDerived,        
      }
    })
  }

  if(document.getElementById('students-by-race')) {
    mount(GenericDonut, {
      target: document.getElementById('students-by-race'),
      props: {
        dataUrl: 'https://webcentral.uc.edu/scorecard/edugradrace-numbersJson.cfm' 
      }
    })
  }

  if(document.getElementById('ghost-gen')) {
    mount(Ghost, {
      target: document.getElementById('ghost-gen'),
      props: {
        store: genderDerived,
        dataFunction: (dataArray)=>{
          console.log('the dataArray for genderDerived', dataArray)
          dataArray.forEach((item, index)=>{
            if (item[1] >= 10) {
              $("#gender").append('<div index="0" class="gen-bar' + index + ' ' + item[0].toLowerCase() + ' " style=" max-width:' + item[1] + '%;"> <span>' + item[0] + ' ' + item[1] + '%<span></div>');
            } else {
              $(".gen-legend").append('<li> <a href="#" class="gen-bar-link' + index + ' ' + item[0].toLowerCase() + '"> <span class="label">' + item[0] + ' </span><span class="value">' + item[1] + '%</span></div>');
            }
          })
        }
      }
    })
  }

  if(document.getElementById('accRate')) {
    mount(StandardDonut, {
      target: document.getElementById('accRate'),
      props: {
        value: '20',
        max: '100',
        suffix: '%',
      }
    });
  }

}